<div class="dropdown dropdown-top dropdown-end">
	<div
		tabindex="0"
		role="button"
		class="btn btn-ghost btn-xs flex items-center gap-1 text-current opacity-90 hover:opacity-100"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			class="h-4 w-4"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.546-3.131 1.57-4.582"
			/>
		</svg>
		<span class="text-xs font-normal normal-case uppercase">
			{{ (translationService.currentLangCode$$$ | async) || 'en' }}
		</span>
	</div>
	<ul
		tabindex="0"
		class="language-selector-menu dropdown-content menu bg-base-100 text-base-content rounded-box z-[1] w-40 border border-base-300/60 p-2 shadow-2xl"
	>
		@for (lang of languages; track lang.code) {
			<li>
				<button
					(click)="setLanguage(lang.code)"
					[class.active]="(translationService.currentLangCode$$$ | async) === lang.code"
					class="language-selector-item flex items-center justify-between rounded-md"
				>
					<div class="flex items-center gap-2">
						<span class="text-lg">{{ lang.flag }}</span>
						<span>{{ lang.name }}</span>
					</div>
					@if ((translationService.currentLangCode$$$ | async) === lang.code) {
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
							fill="currentColor"
							class="h-4 w-4"
						>
							<path
								fill-rule="evenodd"
								d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
								clip-rule="evenodd"
							/>
						</svg>
					}
				</button>
			</li>
		}
	</ul>
</div>
